import { Inject, Injectable, Optional } from '@angular/core';
import { File } from '../models/file';
import { TargetType } from '../models/target-type';
import { FILE_HANDLER, FileHandler } from './file-handler';

@Injectable({
    providedIn: 'root'
})
export class FileService {

    constructor(
        @Optional() @Inject(FILE_HANDLER) private fileHandler: FileHandler | null
    ) { }

    handle(file: File) {
        switch (file.target) {
            case TargetType.download:
                this.download(file.data, file.mimeType, file.name);
                break;
            case TargetType.open:
                this.open(file.data, file.mimeType, file.name);
                break;
            default:
                break;
        }
    }

    open(base64Data: string, mimeType: string, fileName: string) {
        if (this.fileHandler) {
            this.fileHandler.open(base64Data, mimeType, fileName);
            return;
        }

        const blob: Blob = this.base64toBlob(base64Data, mimeType);
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL, '_blank');
    }

    download(base64Data: string, mimeType: string, fileName: string) {
        if (this.fileHandler) {
            this.fileHandler.download(base64Data, mimeType, fileName);
            return;
        }

        const blob: Blob = this.base64toBlob(base64Data, mimeType);
        const link = window.document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    private base64toBlob(base64Data: string, contentType: string) {
        contentType = contentType || '';
        const sliceSize = 1024;
        const byteCharacters = atob(base64Data);
        const bytesLength = byteCharacters.length;
        const slicesCount = Math.ceil(bytesLength / sliceSize);
        const byteArrays = new Array(slicesCount);

        for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            const begin = sliceIndex * sliceSize;
            const end = Math.min(begin + sliceSize, bytesLength);

            const bytes = new Array(end - begin);
            for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        return new Blob(byteArrays, { type: contentType });
    }

}
